import { cn } from "@/lib/utils";
import NextImage from "next/image";

export function Image({ wrapperClassName, "data-tina-field": tinaFieldValue, fill = true, children, src, ...imageProps }) {
  if (!src) return null;

  return (
    <div className={cn("relative", wrapperClassName)} data-tina-field={tinaFieldValue}>
      <NextImage fill={fill} src={src} {...imageProps} />
      {children}
    </div>
  );
}
